import { Paginated } from "../../../old/beheer/store/api/upsellApi";
import { apiRoot } from "../../../old/beheer/store/api/apiRoot";
import { SalesAreaPriceLineForm } from "../dialogs/CreateSalesAreaPriceLineDialog";

const priceLineEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["SalesAreaPriceLine"],
});

export type SalesAreaPriceLine = { id: number; title: string; sales_area_id: number };

export const priceLineApi = priceLineEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchSalesAreaPriceLines: builder.query<
      Paginated<SalesAreaPriceLine>,
      {
        salesAreaId: number;
        pagination: {
          page: number;
          perPage: number;
        };
      }
    >({
      query: ({ salesAreaId, pagination: { page, perPage } }) => {
        return {
          url: `/sales-area-price-lines?filter[sales_area_id][]=${salesAreaId}&per_page=${perPage}&page=${page}`,
          method: "GET",
        };
      },
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "SalesAreaPriceLine" as const, id })),
              { type: "SalesAreaPriceLine", id: "PARTIAL-LIST" },
            ]
          : [{ type: "SalesAreaPriceLine", id: "PARTIAL-LIST" }],
    }),
    createSalesAreaPriceLine: builder.mutation<
      any,
      {
        sales_area_price_line: SalesAreaPriceLineForm;
        sales_area_id: number;
      }
    >({
      invalidatesTags: ["SalesAreaPriceLine"],
      query: (body) => {
        return {
          url: `/sales-area-price-lines`,
          method: "POST",
          body,
        };
      },
    }),
    deleteSalesAreaPriceLine: builder.mutation<any, { id: number }>({
      invalidatesTags: ({ id }) => [{ type: "SalesAreaPriceLine", id }],
      query: ({ id }) => {
        return {
          url: `/sales-area-price-lines/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useFetchSalesAreaPriceLinesQuery,
  useCreateSalesAreaPriceLineMutation,
  useDeleteSalesAreaPriceLineMutation,
} = priceLineApi;
